import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DebugModeShortcut } from '@/components/debug/DebugModeShortcut';
import { AuthenticatedLayout } from '@/components/layouts/AuthenticatedLayout';
import { Toaster } from '@/components/ui/sonner';
import { AppLayout } from '@/features/shared/components/AppLayout';

export const Route = createFileRoute('/_app/app')({
  component: RouteComponent,
  validateSearch: z.object({
    schoolId: z.string().optional(),
    startActivity: z.string().optional(),
  }),
  ssr: false,
});

function RouteComponent() {
  const { schoolId } = Route.useSearch();

  return (
    <>
      <AuthenticatedLayout redirectTo="/login" schoolId={schoolId}>
        <AppLayout />
      </AuthenticatedLayout>
      <Toaster />
      <DebugModeShortcut />
    </>
  );
}
